import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Divider,
  Grid,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { UserInfo } from './types';

export type ClientRowMobileProps = {
  sender: UserInfo;
  receipients: UserInfo[];
};

const ClientRowMobile = (props: ClientRowMobileProps) => {
  return (
    <>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Grid
            container
            sx={{ flexGrow: 1 }}
            alignItems="flex-start"
            direction="row"
            spacing={2}
          >
            <Grid item></Grid>
            <Grid item xs>
              <Grid container>
                <Grid item xs={6}>
                  <Typography fontSize={15} id="nameSummary">
                    {props.sender.name}
                  </Typography>
                  <Typography
                    sx={{ fontSize: 12, color: 'text.secondary' }}
                    id="uid"
                  >
                    {props.sender.phone}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography fontSize={15} align="right" id="displayAmount">
                    {props.receipients.length}
                  </Typography>
                  <Typography
                    sx={{ fontSize: 12, color: 'text.secondary' }}
                    align="right"
                    id="recipientPhone"
                  >
                    Recipients
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </AccordionSummary>
        <Divider />
        <AccordionDetails>
          <Box sx={{ flexGrow: 1 }}>
            {props.receipients.map((recipient) => (
              <Grid
                container
                direction="row"
                spacing={1}
                key={`recipient_${recipient.id}`}
              >
                <Grid item xs={6}>
                  <Box sx={{ mt: 1, ml: 1, padding: 0 }}>
                    <Typography fontSize={13} id={`name_${recipient.id}`}>
                      {recipient.name}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box sx={{ mt: 1, ml: 1, padding: 0 }}>
                    <Typography
                      fontSize={13}
                      align="right"
                      id={`phone_${recipient.id}`}
                    >
                      {recipient.phone}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            ))}
          </Box>
        </AccordionDetails>
        <Divider />
      </Accordion>
    </>
  );
};

export default ClientRowMobile;
